<template>
    <div id="label" class="fields">
        <div class="field">
            <label>
                <!-- 列印紙張大小 -->
                {{ $t('ui.toolbox.core_waybills_label_svg.labels.paper_type') }}
            </label>
            <div v-dropdown class="ui selection dropdown">
                <div class="text">
                    {{ current_page_type.name }}
                </div>
                <i class="dropdown icon"></i>
                <div class="menu">
                    <div
                        v-for="page_type in page_types"
                        @click="current_page_type = page_type"
                        class="item"
                        :class="{
                            'selected active': current_page_type.name == page_type.name
                        }">
                        {{ page_type.name }}
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!errors" class="field">
            <label>&emsp;</label>
            <div class="ui button"
                :class="{
                    loading: is_printing
                }"
                :disabled="!is_printing"
                @click.prevent="add_image_print_job()">
                {{ $t('ui.toolbox.core_waybills_label_svg.btns.print') }}
            </div>
        </div>

        <slot name="button"></slot>
    </div>
</template>

<script>

export default {
    name: "ToolCoreWaybillsLabelSvgLabel",
    props: {
        numbers: {
            type: String,
            default: ""
        },
        label_type: {
            type: String,
            default: ""
        },
        authentication_token: {
            type: String,
            default: ""
        },
        staff_identity: {
            type: String,
            default: ""
        },
        is_show_input: {
            type: Boolean,
            default: true,
        },
        scope: {
            type: String,
            default: "provider"
        },
        node_carrier_name: {
            type: String,
            default: ""
        },
        is_post_method: {
            type: Boolean,
            default: false
        },
        channel: String,
    },
    data() {
        return {
            is_initialized: false,
            is_processing: true,
            is_printing: false,
            post_method: {
                url: "",
                numbers: ""
            },
            errors: "",
            src_array: [],
            current_numbers: "",
            current_page_type: {
                name: "100x100mm",
                value: "100x100"
            },
            page_types: [
                {
                    name: "100x100mm",
                    value: "100x100"
                },
                {
                    name: "100x200mm",
                    value: "100x200"
                },
                {
                    name: "100x190mm",
                    value: "100x190"
                },
                {
                    name: "100x180mm",
                    value: "100x180"
                },
                {
                    name: "A4 3x2",
                    value: "A4"
                },
                {
                    name: "60x20mm",
                    value: "60x20"
                },
            ],
            label_width: 100,
            label_height: 100,
            paper_type: null,
            label_padding: 2,
            material_label_company_regexes: [
                {
                    regex: /(by_express|byexpress|博宇速運|博宇)/i,
                    name: "by_express_logo_no_text"
                },
                {
                    regex: /(tw_568|tw568|台灣物流寶)/i,
                    name: "tw568_logo"
                },
                {
                    regex: /(t_cat|tcat|黑貓宅急便|黑貓)/i,
                    name: "t_cat_logo"
                },
                {
                    regex: /(hct|新竹物流|新竹物)/i,
                    name: "hct_logo"
                },
            ]
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.$bus.$on('print_done_signal', () => {
            this.is_printing = false
        })

        this.init()
    },
    watch: {
        numbers (value) {
            this.init()
        },
        current_numbers (value) {
            this.init()
        },
        current_page_type: {
            deep: true,
            async handler(value) {
                this.is_processing = true
                await this.handle_label()
                // await this.handle_loading_label()
            },
        },
    },
    methods: {
        async init() {
            this.src_array = []
            this.is_processing = true

            await this.check_props()
            await this.handle_label()
            // await this.handle_loading_label()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        add_image_print_job(is_beta = false) {
            if (!this.is_printing) {
                this.$bus.$emit('add_image_print_job',{
                    images: this.src_array,
                    paper_type: this.current_page_type.value,
                    numbers_of_one_page: (this.current_page_type.value == 'A4' && !is_beta) ? 6 : 1
                })
                this.is_printing = true
            }
        },
        check_props() {
            this.errors = ""

            try {
                if (!this.authentication_token) {
                    // throw "pops 參數請給予 authentication_token"
                    throw this.$t('ui.toolbox.core_waybills_label_svg.errors.no_authentication_token')
                }

                var numbers = (this.numbers)
                    ? this.numbers
                    : this.current_numbers

                if (!numbers) {
                    // this.errors = "請輸入號碼"
                    this.errors = this.$t('ui.toolbox.core_waybills_label_svg.errors.no_number')
                }

            } catch (err) {
                this.errors = err
                this.$noty.error(err)
            }
            return Promise.resolve()
        },
        handle_label(is_beta = false) {
            var numbers = (this.numbers)
                ? this.numbers
                : this.current_numbers

            // remove null
            var numbers_array = numbers.split(",")
            _.remove(numbers_array, _.isUndefined)
            numbers_array = _.filter(numbers_array)

            this.src_array = []
            this.label_width = !is_beta ? 100 : null
            this.label_height = !is_beta ? 100 : null
            this.label_padding = 2
            this.paper_type = null

            switch (this.current_page_type.value) {
                case 'A4':
                    this.paper_type = "A4"
                    if (!is_beta) {
                        this.label_width = 105
                        this.label_height = 99
                        this.label_padding = 4.5
                    }
                    break

                case '100x200':
                    this.label_width = 100
                    this.label_height = 200
                    break

                case '100x190':
                    this.label_width = 100
                    this.label_height = 190
                    break

                case '100x180':
                    this.label_width = 100
                    this.label_height = 180
                    break

                case '60x20':
                    this.label_width = 60
                    this.label_height = 20
                    break

                default:
            }
            var parameters = '&padding='+this.label_padding+
                '&authorization='+this.authentication_token

            parameters += (this.label_height) ? '&label_height='+this.label_height : ""
            parameters += (this.label_width) ? '&label_width='+this.label_width : ""

            if (this.paper_type && is_beta) parameters += '&paper_type='+this.paper_type

            if (this.staff_identity) {
                parameters += '&staff_identity='+this.staff_identity
            }

            this.src_array = []
            _.forEach(numbers_array, (number, index) => {
                this.src_array.push({
                    name: number,
                    src: new RestUrl(this.handle_url(is_beta)).parse(
                        {},
                        ".svg?number="+number+parameters
                    )
                })

                if (this.current_page_type.value == '60x20') {
                    this.src_array.push({
                        name: number+"_is_hide_logo=true",
                        src: new RestUrl(this.handle_url(is_beta)).parse(
                            {},
                            ".svg?number="+number+parameters
                        )
                    })
                }

            })
            console.log(this.src_array)

            return Promise.resolve()
        },
        handle_url(is_beta = false) {
            switch (this.scope) {
                case 'provider':
                    return this.$store.state.provider.routes.api_v1_provider_core_waybills_label
                    break
                case 'customer':
                    return this.$store.state.customer.routes.api_v1_customer_core_waybills_label
                    break

                default:
                    return this.$store.state.provider.routes.api_v1_provider_core_waybills_label
            }
        },
    },
    components: {
    },
}
</script>

<style scoped lang="scss">
    .ui.form .fields {
        margin: 0;
    }
    #core_waybills_label_svg .labels {
        display: none;
    }
    img {
        padding: 0;
        margin: 0;
    }
</style>
